import { useState } from "react";
import { LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { ConfirmLogoutDialog } from "@/components/alia/confirm-logout-dialog";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
import { initials } from "@/lib/utils";

export function Topbar() {
  const { session, signOut } = useAuth();
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);

  function handleConfirmLogout() {
    setShowConfirm(false);
    signOut();
    navigate("/login", { replace: true });
  }

  return (
    <>
      <header className="flex h-14 shrink-0 items-center justify-between gap-4 border-b border-border bg-surface/80 px-6 backdrop-blur">
        {/* Status indicator */}
        <div className="flex items-center gap-2">
          <span className="relative flex size-2">
            <span className="absolute inline-flex size-full animate-ping rounded-full bg-success opacity-60" />
            <span className="relative inline-flex size-2 rounded-full bg-success" />
          </span>
          <span className="text-xs font-medium text-muted-foreground">
            Allison activa · 24/7
          </span>
        </div>

        {/* Right side */}
        <div className="flex items-center gap-3">
          {session && (
            <>
              <div className="hidden items-center gap-2.5 rounded-full border border-border bg-surface-2 py-1 pl-1 pr-3 sm:flex">
                <span className="flex size-7 items-center justify-center rounded-full bg-gradient-to-br from-accent-orange to-accent-blue text-[11px] font-semibold text-white">
                  {initials(session.name)}
                </span>
                <span className="text-xs font-medium text-foreground">
                  {session.name}
                </span>
              </div>
              <Button
                variant="ghost"
                size="icon"
                aria-label="Cerrar sesión"
                onClick={() => setShowConfirm(true)}
              >
                <LogOut className="size-4" />
              </Button>
            </>
          )}
        </div>
      </header>

      <ConfirmLogoutDialog
        open={showConfirm}
        onCancel={() => setShowConfirm(false)}
        onConfirm={handleConfirmLogout}
      />
    </>
  );
}
